import { Component, Input } from '@angular/core';
import { faPalette } from '@fortawesome/pro-solid-svg-icons';

export class TableTopLegendVm {
	id: number;
	colorCode: string;
	description: string;
}

@Component({
    selector: 's2-table-top-legend',
    templateUrl: './table-top-legend.component.html',
    styleUrls: ['./table-top-legend.component.scss'],
    standalone: false
})
export class TableTopLegendComponent {

    @Input() legendVms: TableTopLegendVm[];

    faIconName = { faPalette };
}
